import React from "react"
import PropTypes from "prop-types"
import {connect} from "react-redux"

import {ApiForm, FormSection, Field, TitleSection} from "~/components/"
import {Product} from "~/utils/ShelfEntities"
import {useTranslation} from "react-i18next"

const NewProduct = ({match, usingReorderProducts, usingNetPrice}) => {
  const {t} = useTranslation()
  return (
    <ApiForm
      for={Product}
      id={match.params.product_id}
      then="/products"
      submitLabel={t("products.form.submit")}
    >
      <TitleSection>
        <h3>
          {match.params.product_id
            ? t("products.form.editTitle")
            : t("products.form.createTitle")}
        </h3>
      </TitleSection>
      <FormSection label={t("products.form.basic")}>
        <Field label={t("products.form.name")} type="text" name="name" />
        <Field label={t("products.form.unit")} type="text" name="unit" />
        <Field
          label={t("products.form.standardQuantity")}
          type="text"
          name="standard_quantity"
        />
        <Field
          label={t("products.form.productSerialNumber")}
          type="text"
          name="serial_number"
        />
        <Field
          label={t("products.form.externalArticleNumber")}
          type="text"
          name="external_article_number"
        />
      </FormSection>

      {usingNetPrice && (
        <FormSection label={t("products.form.price")}>
          <Field
            label={t("products.form.bruttoPrice")}
            type="number"
            step="0.01"
            name="brutto_price"
          />
          <Field
            label={t("products.form.discountFactor")}
            type="number"
            step="0.01"
            name="discount_factor"
          />
        </FormSection>
      )}

      {usingReorderProducts && (
        <FormSection label={t("products.form.inventory")}>
          <Field
            label={t("products.form.reorderQuantity")}
            type="text"
            name="reorder_quantity"
          />
          <Field
            label={t("products.form.targetQuantity")}
            type="text"
            name="target_quantity"
          />
          <Field
            label={t("products.form.reorderUnitQuantity")}
            type="text"
            name="reorder_unit_quantity"
          />
        </FormSection>
      )}

      <FormSection label={t("products.form.barcodeScanner")}>
        <Field label={t("products.form.barcode")} type="text" name="barcode" />
      </FormSection>
    </ApiForm>
  )
}

NewProduct.propTypes = {
  match: PropTypes.object.isRequired,
  usingReorderProducts: PropTypes.bool.isRequired,
  usingNetPrice: PropTypes.bool.isRequired
}

const mapStateToProps = ({auth}) => {
  const {user} = auth
  const {settings} = user
  const {usingReorderProducts, usingNetPrice} = settings
  return {usingReorderProducts, usingNetPrice}
}

export default connect(mapStateToProps)(NewProduct)



// WEBPACK FOOTER //
// ./src/views/NewProductView.js